import { Divider } from "@src/components/divider/Divider";
import { environment } from "@src/MarqueBlanche";
import { StepName } from "@src/Steps/step/Steps";
import "./footer.scss";

function Basic() {
  return (
    <>
      <p>
        Le contrat Paxivie est un contrat d&apos;assurance prévoyance de la
        mutuelle Tutélaire, personne morale de droit privé à but non lucratif,
        soumise aux dispositions du livre II du Code de la mutualité, inscrite
        au répertoire SIRENE sous le numéro 775 682 164 dont le siège social est
        situé au 157 avenue de France - 75013 Paris.
      </p>
      <p>
        La garantie des atteintes à l&apos;intégrité physique et psychique en
        cas d&apos;accident de la vie courante et la garantie en cas de décès
        accidentel sont assurées et réalisées par Tutélaire.
      </p>
      <p>
        Les garanties d&apos;assistance au contrat Paxivie sont assurées et
        réalisées par Ressources Mutuelles Assistance (RMA), union
        d&apos;assistance soumise aux dispositions du Livre II du Code de la
        mutualité, dont le siège social est situé au 46 rue du Moulin - CS
        92443, 44120 Vertou et immatriculée sous le numéro SIREN 444 269 682.
      </p>
    </>
  );
}

function RightsExercise({ hasCNIL = true }: { hasCNIL?: boolean }) {
  return (
    <>
      <p>
        Pour l&apos;exercice de vos droits, adressez un courrier simple au
        responsable de traitement : Tutélaire, 157 avenue de France, 75013 Paris
        ou un courriel à :{" "}
        <a
          target="_blank"
          rel="noreferrer"
          href="mailto:donneespersonnelles@tutelaire.fr"
        >
          donneespersonnelles@tutelaire.fr
        </a>
        . Toute demande doit être accompagnée d&apos;une copie d&apos;un
        justificatif d&apos;identité comportant la signature de son titulaire et
        doit préciser l&apos;adresse à laquelle la réponse de Tutélaire doit
        parvenir.
        <br />
        Dès réception de votre demande complète, nous répondrons dans un délai
        maximum de 30 jours calendaires.
      </p>
      {hasCNIL && (
        <p>
          Pour plus d&apos;informations relatives à la gestion de vos données,
          consultez à tout moment notre politique de confidentialité sur le site
          internet{" "}
          <a href="https://www.tutelaire.fr" target="_blank" rel="noreferrer">
            www.tutelaire.fr
          </a>{" "}
          ou la demander par courrier simple à Tutélaire, responsable de
          traitement. Vous avez également la possibilité d&apos;introduire une
          réclamation auprès de la Commission Nationale de l&apos;Informatique
          et des Libertés (
          <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">
            www.cnil.fr
          </a>
          ).
        </p>
      )}
    </>
  );
}

function DataProtectionNotice({
  hasCNIL,
  children,
}: {
  hasCNIL?: boolean;
  children: React.ReactNode;
}) {
  return (
    <>
      {children}
      <RightsExercise hasCNIL={hasCNIL} />
      <Divider />
      <Basic />
    </>
  );
}

function CollectData() {
  return (
    <DataProtectionNotice>
      <p>
        Les informations recueillies dans le présent formulaire, ont pour
        finalité la réalisation du devis et la gestion du risque. Vous disposez
        notamment des droits d&apos;accès, de rectification, d&apos;opposition,
        de portabilité, d&apos;effacement et de limitation du traitement vous
        concernant.
      </p>
    </DataProtectionNotice>
  );
}

function CollectAndTreatData() {
  return (
    <DataProtectionNotice>
      <p>
        Les informations recueillies dans le présent formulaire, ont pour
        finalité la gestion et l&apos;exécution du contrat ainsi que la gestion
        du risque inhérent à votre demande de souscription. Vous disposez
        notamment des droits d&apos;accès, de rectification, d&apos;opposition,
        de portabilité, d&apos;effacement et de limitation du traitement vous
        concernant.
      </p>
    </DataProtectionNotice>
  );
}

function CollectAndTreatAndProspectCommercialData() {
  return (
    <DataProtectionNotice>
      <p>
        Les informations recueillies dans le présent formulaire, ont pour
        finalité la gestion et l&apos;exécution du contrat ainsi que la gestion
        du risque inhérent à votre demande de souscription et si accord de votre
        part, la prospection commerciale. Vous disposez notamment des droits
        d&apos;accès, de rectification, d&apos;opposition, de portabilité,
        d&apos;effacement et de limitation du traitement vous concernant.
      </p>
    </DataProtectionNotice>
  );
}

function CollectAndContactData({ hasCNIL }: { hasCNIL?: boolean }) {
  return (
    <DataProtectionNotice hasCNIL={hasCNIL}>
      <p>
        Les informations recueillies dans le présent formulaire, ont pour
        finalités de pouvoir vous rappeler et répondre à vos questions. Vous
        disposez notamment des droits d&apos;accès, de rectification,
        d&apos;opposition, de portabilité, d&apos;effacement et de limitation du
        traitement vous concernant.
      </p>
    </DataProtectionNotice>
  );
}

function COMMON_INFO() {
  return (
    <div className="footer__common-info">
      <div className="footer__common-info__logos">
        <img alt="logo-tutelaire" src="/logo-tutelaire.png" />
        <img
          alt="logo-mutualite-francaise"
          src="/logo-mutualite-francaise.png"
        />
      </div>
      <div className="footer__common-info__links">
        <a
          href="https://www.tutelaire.fr/mentions-legales-cookies"
          target="_blank"
          rel="noreferrer"
        >
          Mentions légales
        </a>
        <a
          href="https://www.tutelaire.fr/protection-des-donnees"
          target="_blank"
          rel="noreferrer"
        >
          Protection des données | Tutélaire mutuelle humaniste
        </a>
        <div>
          <a
            href={environment.current.docReglement}
            target="_blank"
            rel="noreferrer"
          >
            Réglement du contrat Paxivie
          </a>
          {" - "}
          <a
            href={environment.current.docDIPA}
            target="_blank"
            rel="noreferrer"
          >
            DIPA Paxivie
          </a>
        </div>
      </div>
    </div>
  );
}

const FOOTER_CONTENT_MAP: Record<StepName, React.ReactNode> = {
  LANDING: <Basic />,
  TARIF: <Basic />,
  CONFIRMATION_SIMULATION: <Basic />,
  SUBSCRIPTION_INTRODUCTION: <CollectAndTreatData />,
  VALIDATE_POINTS: <CollectAndTreatData />,
  CONSENT: <CollectAndTreatData />,
  CHECK_YOUR_MAIL: <CollectAndContactData hasCNIL={false} />,
  RECAP_SOUSCRIPTION: <CollectAndTreatData />,
  AVANT_DE_POURSUIVRE: <CollectAndTreatData />,
  NUM_SECU: <CollectAndTreatData />,
  POLITIQUEMENT_EXPOSEE: <CollectAndTreatData />,
  BENEFICIAIRES: <CollectAndTreatData />,
  CONSENT_SOUSCRIPTION: <CollectAndTreatAndProspectCommercialData />,
  MANDAT_PRELEVEMENT: <CollectAndTreatData />,
  PIECES_JUSTIFICATIVES: <CollectAndTreatData />,
  RECAP_SIGNATURE: <CollectAndTreatData />,
  SUCCESS: <CollectAndTreatData />,
};

export default function Footer({ stepName }: { stepName: StepName }) {
  return (
    <div className="footer">
      <div>
        {FOOTER_CONTENT_MAP[stepName] || <CollectData />}
        <COMMON_INFO />
      </div>
    </div>
  );
}
